import { useMemo } from "react";
import { Optional } from "../../../types";
import { Text } from "../../text";
import styles from "./good-deal-brand.module.css";

export type GoodDealBrandProps = {
  size?: Optional<"small">;
};

export function GoodDealBrand({ size }: GoodDealBrandProps) {
  const className = useMemo(() => {
    if (size === "small") {
      return `${styles.Container} ${styles.Small}`;
    }

    return styles.Container;
  }, [size]);

  return (
    <div className={className} data-qa="good-deal-brand">
      <Text color="#fff" variant="body-semibold-2xsmall">
        Abaixo da fipe
      </Text>
    </div>
  );
}
